Date.prototype.yyyymmdd = function () {
  let mm =
    this.getMonth() < 9 ? '0' + (this.getMonth() + 1) : this.getMonth() + 1;
  let dd = this.getDate() < 10 ? '0' + this.getDate() : this.getDate();
  return [this.getFullYear(), mm, dd].join('');
};

Date.prototype.toFormatString = function (format) {
  let year = this.getFullYear();

  let month = this.getMonth() + 1;

  let day = this.getDate();

  let hour = this.getHours();

  let minute = this.getMinutes();

  let second = this.getSeconds();

  if (format == null) format = 'yyyy-MM-dd';

  format = format.replace('yyyy', year);

  format =
    month < 10
      ? format.replace('MM', '0' + month)
      : format.replace('MM', month);

  format = format.replace('M', month);

  format =
    day < 10 ? format.replace('dd', '0' + day) : format.replace('dd', day);

  format = format.replace('d', day);

  format =
    hour < 10 ? format.replace('HH', '0' + hour) : format.replace('HH', hour);

  format =
    minute < 10
      ? format.replace('mm', '0' + minute)
      : format.replace('mm', minute);

  format =
    second < 10
      ? format.replace('ss', '0' + second)
      : format.replace('ss', second);

  return format;
};

const dateMonthEnglishConvert = (month) => {
  switch (Number(month)) {
    case 1:
      return 'January';
    case 2:
      return 'February';
    case 3:
      return 'March';
    case 4:
      return 'April';
    case 5:
      return 'May';
    case 6:
      return 'Jun';
    case 7:
      return 'July';
    case 8:
      return 'August ';
    case 9:
      return 'September';
    case 10:
      return 'October';
    case 11:
      return 'November';
    case 12:
      return 'December';
  }
};

export default {
  dateFormatter: function (time, type) {
    let _type = type === undefined ? 'default' : type;
    if (!['default', 'onlyDate', 'onlyTime'].includes(_type)) {
      throw new Error('ERROR! DATE FORMATTER TYPE IS NOT VALID');
    }
    const timeObj = new Date(time);
    switch (_type) {
      case 'basic':
        return (
          timeObj.getFullYear() +
          '.' +
          zeroAddOnHead(timeObj.getMonth()) +
          '.' +
          zeroAddOnHead(timeObj.getDate()) +
          ' ' +
          zeroAddOnHead(timeObj.getHours()) +
          ':' +
          zeroAddOnHead(timeObj.getMinutes())
        );
      case 'default':
        return (
          timeObj.getFullYear() +
          '/' +
          zeroAddOnHead(timeObj.getMonth()) +
          '/' +
          zeroAddOnHead(timeObj.getDate()) +
          ' ' +
          zeroAddOnHead(timeObj.getHours()) +
          ':' +
          zeroAddOnHead(timeObj.getMinutes())
        );
      default:
        new Error('ERROR! DATE FORMAT NOT VALID');
    }
  },
  mathDDay: (dat1, dat2) => {
    let diff = dat2.getTime() - dat1.getTime(); //날짜 빼기
    const isDone = diff > 0 ? false : true;
    diff = Math.abs(diff);

    const currSec = 1000; // 밀리세컨
    const currMin = 60 * 1000; // 초 * 밀리세컨
    const currHour = 60 * 60 * 1000; // 분 * 초 * 밀리세컨
    const currDay = 24 * 60 * 60 * 1000; // 시 * 분 * 초 * 밀리세컨

    const day = Math.floor(diff / currDay); //d-day 일
    const hour = Math.floor(diff / currHour); //d-day 시
    const min = Math.floor(diff / currMin); //d-day 분
    const sec = Math.floor(diff / currSec); //d-day 초

    let viewHour = hour - day * 24;
    let viewMin = min - hour * 60;
    let viewSec = sec - min * 60;

    viewHour = viewHour < 10 ? '0' + viewHour : viewHour;
    viewMin = viewMin < 10 ? '0' + viewMin : viewMin;
    viewSec = viewSec < 10 ? '0' + viewSec : viewSec;

    //시분초 말고 일까지만 보여주면 day만 노출하면 된다.
    return { day, viewHour, viewMin, viewSec, isDone };
  },
  basicForamt: (date, type) => {
    // let format = 'mm-dd-yyyy'
    if (
      date == undefined ||
      date == null ||
      date == 'undefined' ||
      date == '' ||
      date.length != 8
    )
      return date;

    return (
      date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 4)
    );
  },
  dateTimestampConvert: (date) => {
    if (date == undefined || date == null || date == 'undefined' || date == '')
      return '';

    return dateMonthEnglishConvert(date[1]) + ', ' + date[2] + ', ' + date[0];
  },
  dateConvert: (date) => {
    if (date == undefined || date == null || date == 'undefined' || date == '')
      return '';

    return (
      dateMonthEnglishConvert(date.substr(4, 2)) +
      ', ' +
      date.substr(6, 4) +
      ', ' +
      date.substr(0, 4)
    );
  },
  localDateTimeConvert: (date, char = '.') => {
    if (date == undefined || date == null || date == 'undefined' || date == '')
      return '';

    return date[0] + char + date[1] + char + date[2];
  },
  // localDateTimeStringConvert: (date) => {
  //   if (date == undefined || date == null || date == 'undefined' || date == '')
  //     return '';

  //   return (
  //     String(date[0]).padStart(4, '0') +
  //     String(date[1]).padStart(2, '0') +
  //     String(date[2]).padStart(2, '0')
  //   );
  // },
  dateTimePickerConvert: (value) => {
    const date = value;

    if (
      value == undefined ||
      value == null ||
      value == 'undefined' ||
      value == ''
    )
      return [];
    let year = date.getFullYear().toString().slice(-4); //년도 뒤에 두자리
    let month = ('0' + (date.getMonth() + 1)).slice(-2); //월 2자리 (01, 02 ... 12)
    let day = ('0' + date.getDate()).slice(-2); //일 2자리 (01, 02 ... 31)
    let hour = ('0' + date.getHours()).slice(-2); //시 2자리 (00, 01 ... 23)
    let minute = ('0' + date.getMinutes()).slice(-2); //분 2자리 (00, 01 ... 59)
    let second = ('0' + date.getSeconds()).slice(-2); //초 2자리 (00, 01 ... 59)

    // return [
    //   Number(year),
    //   Number(month),
    //   Number(day),
    //   Number(hour),
    //   Number(minute),
    //   Number(second),
    // ];
    return year + month + day;
  },
  dateAndTimePickerStringConvert: (value) => {
    const date = value;
    if (
      value == undefined ||
      value == null ||
      value == 'undefined' ||
      value == ''
    )
      return [];

    let year = date.getFullYear().toString().slice(-4); //년도 뒤에 두자리
    let month = ('0' + (date.getMonth() + 1)).slice(-2); //월 2자리 (01, 02 ... 12)
    let day = ('0' + date.getDate()).slice(-2); //일 2자리 (01, 02 ... 31)
    let hour = ('0' + date.getHours()).slice(-2); //시 2자리 (00, 01 ... 23)
    let minute = ('0' + date.getMinutes()).slice(-2); //분 2자리 (00, 01 ... 59)
    let second = ('0' + date.getSeconds()).slice(-2); //초 2자리 (00, 01 ... 59)

    return (
      year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    );
  },
  dateTimePickerConvertToDate: (value) => {
    if (
      value == undefined ||
      value == null ||
      value == 'undefined' ||
      value == ''
    ) {
      return new Date();
    }

    let date = new Date(
      value.slice(0, 4),
      Number(value.slice(4, 6)) - 1,
      value.slice(6, 8)
    );
    return date;
  },
  timestampToYYMMDDHHmmss: (date) => {
    if (date == undefined || date == null || date == 'undefined' || date == '')
      return '';
    let year = date[0]; //년도 뒤에 두자리
    let month = date[1]; //월 2자리 (01, 02 ... 12)
    let day = date[2]; //일 2자리 (01, 02 ... 31)
    let hour = date[3]; //시 2자리 (00, 01 ... 23)
    let minute = date[4]; //분 2자리 (00, 01 ... 59)
    let second = date[5]; //초 2자리 (00, 01 ... 59)
    return (
      year +
      '-' +
      (month < 10 ? '0' + month : month) +
      '-' +
      (day < 10 ? '0' + day : day) +
      ' ' +
      (hour < 10 ? '0' + hour : hour) +
      ':' +
      (minute < 10 ? '0' + minute : minute) +
      ':' +
      (second < 10 ? '0' + second : second)
    );
  },
  dateToYYYYMMDDHHmmss: (date) => {
    return (
      date.getFullYear() +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      ('0' + date.getDate()).slice(-2) +
      ('0' + date.getHours()).slice(-2) +
      ('0' + date.getMinutes()).slice(-2) +
      ('0' + date.getSeconds()).slice(-2)
    );
  },
  dateToYYMMDD_HHmmss: () => {
    let date = new Date();
    if (date == undefined || date == null || date == 'undefined' || date == '')
      return '';
    let year = date.getFullYear().toString().slice(-4); //년도 뒤에 두자리
    let month = ('0' + (date.getMonth() + 1)).slice(-2); //월 2자리 (01, 02 ... 12)
    let day = ('0' + date.getDate()).slice(-2); //일 2자리 (01, 02 ... 31)
    let hour = ('0' + date.getHours()).slice(-2); //시 2자리 (00, 01 ... 23)
    let minute = ('0' + date.getMinutes()).slice(-2); //분 2자리 (00, 01 ... 59)
    let second = ('0' + date.getSeconds()).slice(-2); //초 2자리 (00, 01 ... 59)
    return year + month + day + '_' + hour + minute + second;
  },
  dateHHmmssReset: (date) => {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);

    return date;
  },
  addDays: (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  },
  yearComboBox: () => {
    var dt = new Date();
    var com_year = dt.getFullYear();
    let years = [];
    for (var y = com_year - 10; y <= com_year; y++) {
      years.unshift(y);
    }
    return years;
  },
};
